import { atom } from 'recoil';

const localeState = atom({
  key: 'localeState',
  default: 'en',
});

export { localeState };
